module.exports = __webpack_public_path__ + "static/home_gitgithub-140e8d090f36c0ec844474f533bf4d56.png";